import extractErrorMessage from '../../../shared/utils/extractErrorMessage';
import { authClient } from '../../../shared/api/client';

const isOkStatus = (status) => status >= 200 && status < 300;

export const sendUserNotification = async (userId, payload) => {
  try {
    const response = await authClient.post(`/users/notify/${userId}`, payload);
    return {
      data: response.data,
      status: response.status,
      ok: isOkStatus(response.status),
      message: response.data?.message || 'Notifikacija poslata.',
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Doslo je do greske pri slanju notifikacije.'
    );
    return {
      data: null,
      status: error?.response?.status || null,
      ok: false,
      message: message,
    };
  }
};
